<div [class]="toastCardClass">
  <app-display-icon
    class="shared-toast-icon"
    [border]="false"
    [colour]="toastIconColour"
    [icon]="toastIcon">
  </app-display-icon>
  <div class="shared-toast-copy">
    @if (header) {
      <p class="shared-toast-header">{{ header }}</p>
    }
    <p class="shared-toast-message">{{ message }}</p>
  </div>
  @if (buttons.length > 0) {
    <div class="shared-toast-actions">
      @for (button of buttons; track button.text) {
        <button
          type="button"
          class="shared-toast-action"
          (click)="onButtonClick(button)">
          {{ button.text }}
        </button>
      }
    </div>
  }
</div>
